<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">隐身</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="introduce">
      <div class="txt">
        <span>功能介绍：隐身功能只针对会员有效，通过隐身功能可以修改自己对外显示的魅力值和豪气值，修改范围如下</span>
      </div>
    </div>

    <div class="content">
      <div class="slider-container ub ub-ver">
        <div class="value">对外展示豪气值: <span>{{ user.show_coin }}</span></div>
        <input type="range" min="0" :max="user.coin_total" v-model="user.show_coin" />
        <div class="ub ub-pc ub-ac2 range">
          <span>0</span>
          <span>{{ user.coin_total }}</span>
        </div>
        <div class="range-label">可调节范围: 0-{{ user.coin_total }}</div>
      </div>

      <div class="menu-line"></div>

      <div class="slider-container ub ub-ver">
        <div class="value">对外展示魅力值: <span>{{ user.show_score }}</span></div>
        <input type="range" min="0" :max="user.score_total" v-model="user.show_score" />
        <div class="ub ub-pc ub-ac2 range">
          <span>0</span>
          <span>{{ user.score_total }}</span>
        </div>
        <div class="range-label">可调节范围: 0-{{ user.score_total }}</div>
      </div>

      <div class="ub ub-ac ub-pc vip-tip" v-if="user.vip_level <= 0">
        <span>此功能为会员特权功能，<a @click="goto_vip()">点击成为会员~</a></span>
      </div>

      <div class="ub ub-pc ub-ac">
        <div class="btn"  @click="save()"><span>完成</span></div>
      </div>

    </div>
  </div>
</template>

  <script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      user: {
        score_total: 0,
        coin_total: 0,
        show_coin: 0,
        show_score: 0,
        vip_level: 0,
      },
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_reload_userinfo", "act_get_userinfo"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_vip() {
      this.$router.push({ name: "vip_center" });
    },
    init_page() {
      var uid = this.$store.state.uid;
      var self = this;

      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          // console.log(JSON.stringify(u));
          self.user.score_total = u.score_total;
          self.user.coin_total = u.coin_total;
          self.user.uid = u.uid;
          self.user.show_coin = u.show_coin;
          self.user.show_score = u.show_score;
          self.user.vip_level = u.vip_level;
        },
      });
    },

    save() {
      //检查是否是vip,如果不是不给用
      if (this.user.vip_level <= 0) {
        this.$toast.center("此功能为会员专属！");
        return false;
      }

      //后台保存信息
      var self = this;
        var uid = this.$store.state.uid;
        
        var send_data = { "show_coin": self.user.show_coin,"show_score":self.user.show_score };
        var data = {
          url: "/App/User_ModifyBaseInfo",
          data: {
            uid: uid,
            data: JSON.stringify(send_data),
          },
          success: function (data_serve) {
            if (data_serve.state == "1") {
              self.act_reload_userinfo({
                uid: uid,
                success: function (info) {
                  self.back();
                },
              });
            }
          },
        };
        self.post(data);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background-color: #EFEFEF;
}

.introduce {
  margin-top: 0.5rem;
  padding: 0 0.8rem;
  .txt {
    padding: 0.5rem 0.8rem;
    border-radius: 0.5rem;
    background-color: #FDFDFD;
    span {
      font-size: 0.75rem;
      color: #333;
    }
  }
}
.content {
  padding: 0.8rem;
  margin-top: 1rem;
  background-color: #FDFDFD;
  background-size: 100% 100%;
  border-radius: 1rem;
  .slider-container {
    margin-top: 1rem;
    input[type="range"] {
      margin-top: 1rem;
      -webkit-appearance: none;
      height: 0.3rem;
      background: #BA61FF;
      border-radius: 1rem;
      outline: none;
      opacity: 0.7;
      transition: opacity 0.2s;
    }
    input[type="range"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 1.2rem;
      height: 1.2rem;
      background: #BA61FF;
      cursor: pointer;
      border-radius: 50%;
    }
    input[type="range"]::-moz-range-thumb {
      width: 1.2rem;
      height: 1.2rem;
      background: #BA61FF;
      cursor: pointer;
      border-radius: 50%;
    }
    .value {
      color: #333;
      font-size: 1rem;
      font-weight: bold;
    }
    .range {
      margin-top: 1rem;
      span {
        font-size: 0.9rem;
        color: #333;
      }
    }
    .range-label {
      margin-top: 1rem;
      font-size: 0.75rem;
      color: #BA61FF;
    }
  }
}
.menu-line {
  margin: 1rem 0;
  border-top: 1px solid #EFEFEF;
}

.btn {
  margin: 1rem 0;
  padding: 0.5rem 8rem;
  border-radius: 2rem;
  background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
  span {
    font-size: 1rem;
    font-weight: bold;
    color: #FFFFFF;
  }
}
.vip-tip {
  margin-top: 1rem;
  span {
    font-size: 0.65rem;
    color: #333;
    a {
      color: #BA61FF;
    }
  }

}

.container-dark {
  background-color: #2f2e33;
  .introduce {
    .txt {
      background-color: #2c2b30;
      span {
        color: #888;
      }
    }
  }
  .content {
    background-color: #2c2b30;
    .slider-container {
      .value {
        color: #888;
      }
      .range {
        span {
          color: #888;
        }
      }
    }
    .menu-line {
      border-top: 1px solid #404040;
    }
  }
  .vip-tip {
    span {
      color: #888;
    }
  }
}
</style>
